var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrFwd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 18,
    viewBox: "0 0 9 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.32209 17.4119C1.03418 17.4125 0.755165 17.3122 0.533476 17.1285C0.408704 17.0251 0.305566 16.898 0.229967 16.7547C0.154369 16.6113 0.107796 16.4544 0.0929155 16.293C0.0780355 16.1316 0.095141 15.9689 0.143252 15.8141C0.191363 15.6594 0.269533 15.5156 0.373288 15.3911L5.89359 8.78644L0.570443 2.16947C0.468088 2.04343 0.391652 1.8984 0.345528 1.74273C0.299404 1.58705 0.284502 1.42379 0.301678 1.26234C0.318854 1.10088 0.367769 0.944415 0.445613 0.801926C0.523456 0.659437 0.628693 0.533737 0.755274 0.432052C0.882766 0.319876 1.03207 0.235263 1.19381 0.183524C1.35555 0.131784 1.52625 0.114036 1.69517 0.131391C1.8641 0.148747 2.02762 0.200832 2.17546 0.284378C2.3233 0.367925 2.45228 0.481128 2.5543 0.616884L8.50588 8.01015C8.68712 8.23063 8.78619 8.50719 8.78619 8.79261C8.78619 9.07802 8.68712 9.35458 8.50588 9.57506L2.34483 16.9683C2.22121 17.1174 2.06419 17.2353 1.88649 17.3124C1.7088 17.3895 1.51543 17.4236 1.32209 17.4119Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrFwd);
export default __webpack_public_path__ + "static/media/arr_fwd.0935630d7b032c36618a51fe76b4512f.svg";
export { ForwardRef as ReactComponent };